import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cfunction() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  return (
    <div>
       <Sides/>
       <Helmet>
 
 <title>Function in c tutorial For Beginners</title>
 <meta name="description" content="Function in c tutorial for beginners.Function in c is a set of statements enclosed in {} written under name.,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,What is Function in C,learn code in free,c programming tutorial for beginners,learn code in free online,c function,c in function,for function c,c function pointer,c function prototype,c function declaration,c function call,c function exit,c function in r,c function program" />
 <link rel="canonical" href="https://www.codeexampler.com/c-function" />
 </Helmet>

 <div className='lg:pl-56'>
      <h1 className="m-4 mh1">What is Function in C</h1>
      <div className="first">
        <a href="/c-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-user-defined-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
      <p className="para mt-4">1, Function in c is a set of statements enclosed in {} written under a name.<br />
2, A function is defined only one time and can be used for only no time.<br />

3, With the help of a function, a big program can be more flexible.<br />
      </p>

      <h2 className="mt-4 mh2">Types of Function in a c programming language:
</h2>
      <h3 className="mt-4 mh3">1,Library function <br />
2,User defined function<br />
      </h3>
      <h2 className="mt-4 mh2">1,Library function in c:</h2>
      <p className="mt-4 para">library function in c these function are pre-defined function in the library of c.if we want to use an library function then we have to include its header file at the top of the programme<br />
&#60;stdio.h&#62;<br />
 printf()<br />
gets()<br />
Getchar()<br />
Scanf()<br />
Puts()<br />
Putchar()<br />
Etc.<br />
      </p>


 

      <h2 className='headings'>Q-Math sqrt() by using function in a C programming language?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">math.h</span>
                <span className="qwerty-4">&#62; </span>
            {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>
            {"\n"}
                <span className="qwerty-4" >&#123; </span>
            {"\n"}
                  <span className="qwerty-3"> double</span>
                <span className="qwerty-5"> i</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">;</span>
                {"\n"}
                <span className="qwerty-5"> i </span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1"> 24</span>
                <span className="qwerty-4">;</span>
            {"\n"}                
            <span className="qwerty-5"> a </span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-3"> sqrt</span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">);</span>
            {"\n"}
                <span className="qwerty-8"> printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-10">Square Root is </span>
                <span className="qwerty-3">%If</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">);</span>
        {"\n"}              
              <span className="qwerty-7"> return</span>
              <span className="qwerty-3"> 0</span>
              <span className="qwerty-4">; </span>
                  {"\n"}
                <span className="qwerty-4" >&#125;</span>       
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                    
                    {"\n"}
                        <span className="qwerty-5">Square Root is </span>                   
                        <span className="qwerty-1">4.898979</span>
                    {"\n"}{"\n"}                 
                </code>
                </pre>
                </div>


      <h2 className="mt-4 mh2">Exit(0):</h2>

      <p className="mt-4 para">&#60;stdlib.h&#62;<br />
&#60;process.h&#62;<br />
This position is used to terminate the program correctly.

</p>


      <h2 className='headings'>Q-Exit using a function in a C programming language?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdlib.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">process.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}
                 <span className="qwerty-4" >&#123; </span>
             {"\n"}             
             <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">Program Exit 1</span>
                 <span className="qwerty-4">");</span>
         {"\n"}              
                 <span className="qwerty-3"> exit</span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-1">0</span>
                 <span className="qwerty-4">);</span>
             {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">Program Exit 2</span>
                 <span className="qwerty-4">");</span>
         {"\n"}              
               <span className="qwerty-7"> return</span>
               <span className="qwerty-3"> 0</span>
               <span className="qwerty-4">; </span>
                   {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >                    
                     {"\n"}
                         <span className="qwerty-5">Program Exit </span>                   
                         <span className="qwerty-1">1</span>
                     {"\n"}{"\n"}                 
                 </code>
                 </pre>
                 </div>


      <h2 className="mt-4 mh2">Character function:
</h2>
      <p className="mt-4 para">
        Getchar()-to input a single character<br />
        Getche()- input character and echo<br />
        Getch()- input  character without echo<br />
</p>
      <h3 className="mt-4 mh2">Getchar() function in c programming</h3>
   

      <h2 className='headings'>Q-Write a program that uses getchar() in the C funtion?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}
                 <span className="qwerty-4" >&#123; </span>
             {"\n"}
                 <span className="qwerty-3"> char</span>
                 <span className="qwerty-5"> ch</span>
                 <span className="qwerty-4">;</span>
                 {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">Enter a Char </span>
                 <span className="qwerty-4">");</span>
             {"\n"}                
             <span className="qwerty-5">  ch </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-3"> getchar</span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-4">);</span>
             {"\n"}
                 <span className="qwerty-8">   printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">*</span>
                 <span className="qwerty-4">");</span>
             {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">\n You entered =  </span>
                 <span className="qwerty-3">%c</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-5">ch</span>
                 <span className="qwerty-4">);</span>
         {"\n"}              
                 <span className="qwerty-7"> return</span>
                 <span className="qwerty-3"> 0</span>
                 <span className="qwerty-4">; </span>
                   {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >                    
                     {"\n"}
                         <span className="qwerty-5">Enter a Char </span>                   
                         <span className="qwerty-1">v</span>
                     {"\n"}
                         <span className="qwerty-1">*</span>
                     {"\n"}                 
                         <span className="qwerty-3">You entered = </span>                   
                         <span className="qwerty-1">v</span>
                     {"\n"}{"\n"}                 
                 </code>
                 </pre>
                 </div>


      <h2 className="mt-4 mh2">Getche() function in c programming</h2>

      <h2 className='headings'>Q-Write a program that uses getche() in the C funtion?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}
                 <span className="qwerty-4" >&#123; </span>
             {"\n"}
                 <span className="qwerty-3"> char</span>
                 <span className="qwerty-5"> ch</span>
                 <span className="qwerty-4">;</span>
                 {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">Enter a Char </span>
                 <span className="qwerty-4">");</span>
             {"\n"}                
             <span className="qwerty-5">  ch </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-3"> getche</span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-4">);</span>
             {"\n"}
                 <span className="qwerty-8">   printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">*</span>
                 <span className="qwerty-4">");</span>
             {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">\n You entered =  </span>
                 <span className="qwerty-3">%c</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-5">ch</span>
                 <span className="qwerty-4">);</span>
         {"\n"}              
                 <span className="qwerty-7"> return</span>
                 <span className="qwerty-3"> 0</span>
                 <span className="qwerty-4">; </span>
                   {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >                    
                     {"\n"}
                         <span className="qwerty-5">Enter a Char </span>                   
                         <span className="qwerty-1">b *</span>
                     {"\n"}                
                         <span className="qwerty-3">You entered = </span>                   
                         <span className="qwerty-1">b</span>
                     {"\n"}{"\n"}                 
                 </code>
                 </pre>
                 </div>


      <h3 className="mt-4 mh2">Getch() function in C programming</h3>



      <h2 className='headings'>Q-Write a program that uses getch() in the C funtion?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}
                 <span className="qwerty-4" >&#123; </span>
             {"\n"}
                 <span className="qwerty-3"> char</span>
                 <span className="qwerty-5"> ch</span>
                 <span className="qwerty-4">;</span>
                 {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">Enter a Char </span>
                 <span className="qwerty-4">");</span>
             {"\n"}                
             <span className="qwerty-5">  ch </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-3"> getch</span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-4">);</span>
             {"\n"}
                 <span className="qwerty-8">   printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">*</span>
                 <span className="qwerty-4">");</span>
             {"\n"}
                 <span className="qwerty-8"> printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-10">\n You entered =  </span>
                 <span className="qwerty-3">%c</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-5">ch</span>
                 <span className="qwerty-4">);</span>
         {"\n"}              
                 <span className="qwerty-7"> return</span>
                 <span className="qwerty-3"> 0</span>
                 <span className="qwerty-4">; </span>
                   {"\n"}
                 <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >                    
                     {"\n"}
                         <span className="qwerty-5">Enter a Char </span>                   
                         <span className="qwerty-1">k *</span>
                     {"\n"}                
                         <span className="qwerty-3">You entered = </span>                   
                         <span className="qwerty-1">k</span>
                     {"\n"}{"\n"}                 
                 </code>
                 </pre>
                 </div>


      <h4 className="mt-4 mh2">*&#60;dos.h&#62;</h4>
      <h4 className="mt-4 mh2">1,Sleep()<br />
2,delay()<br />
      </h4>

      <p className="mt-3 para">Both functions are used to pause the execution of the program for a fixed period.
</p>



      <h2 className="headings">Q-Write a Program to print a number from 1 to 10 using 1 second?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
                                {"\n"} 
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">dos.h</span>
                 <span className="qwerty-4">&#62; </span>
                                {"\n"} 
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                {"\n"}
                <span className="qwerty-4" >&#123; </span>            
                {"\n"}
                <span className="qwerty-3"> int</span>
                <span className="qwerty-5"> i</span>                     
                <span className="qwerty-4">;</span>                     
                {"\n"}
                <span className="qwerty-6"> for</span>
                <span className="qwerty-4"> (</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">; </span>
                <span className="qwerty-5">i</span>
                <span className="qwerty">&#60;=</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty">++</span>
                <span className="qwerty-4">;</span>                                   
              <span className="qwerty-4">)</span>
                {"\n"} 
                <span className="qwerty-4"> &#123;</span>
                {"\n"}
                <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-10"> \n</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5"> i</span>
                <span className="qwerty-4">);</span>
                {"\n"}
                <span className="qwerty-3">  sleep</span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">);</span>
                <span className="qwerty-5">//delay(1000);</span>
                {"\n"}
                      <span className="qwerty-4"> &#125;</span>
                {"\n"}
                <span className="qwerty-7"> return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
                    {"\n"}
                <span className="qwerty-4">&#125;</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div> 
        <h4 className='headings'>Output :</h4>
                <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
                  <pre style={{maxHeight:"100vh"}}>
                        <code >                  
                        {"\n"}      
                          <span className="qwerty-1">1</span>                   
                          {"\n"}         
                          <span className="qwerty-1">2</span>                   
                          {"\n"}         
                          <span className="qwerty-1">3</span>                   
                          {"\n"}         
                          <span className="qwerty-1">4</span>                   
                          {"\n"}         
                          <span className="qwerty-1">5</span>                   
                          {"\n"}         
                          <span className="qwerty-1">6</span>                   
                          {"\n"}         
                          <span className="qwerty-1">7</span>                   
                          {"\n"}         
                          <span className="qwerty-1">8</span>                   
                          {"\n"}         
                          <span className="qwerty-1">9</span>                   
                          {"\n"}         
                          <span className="qwerty-1">10</span>                   
                          {"\n"}         
                          {"\n"}         
                        </code>
                        </pre>
                        </div> 

      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/c-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-user-defined-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
  )
}   
export default Cfunction;